export const HEX_COLOR_PATTERN = /^#[0-9A-F]{6}$/i;

export const normalizeHexColor = (value: string): string => {
  const normalized = value.trim().replace(/^#/, '').toUpperCase();

  return `#${normalized}`;
};

const getRgbChannelsFromHue = (
  hue: number,
  chroma: number,
  secondaryComponent: number
): [number, number, number] => {
  if (hue < 60) return [chroma, secondaryComponent, 0];
  if (hue < 120) return [secondaryComponent, chroma, 0];
  if (hue < 180) return [0, chroma, secondaryComponent];
  if (hue < 240) return [0, secondaryComponent, chroma];
  if (hue < 300) return [secondaryComponent, 0, chroma];

  return [chroma, 0, secondaryComponent];
};

export const hslTokenToHexColor = (value: string): string | null => {
  const [hue, saturation, lightness] = value
    .trim()
    .split(/\s+/)
    .map((part) => Number(part.replace('%', '')));

  if (
    !Number.isFinite(hue) ||
    !Number.isFinite(saturation) ||
    !Number.isFinite(lightness) ||
    saturation < 0 ||
    saturation > 100 ||
    lightness < 0 ||
    lightness > 100
  ) {
    return null;
  }

  const normalizedHue = ((hue % 360) + 360) % 360;
  const saturationDecimal = saturation / 100;
  const lightnessDecimal = lightness / 100;

  const chroma = (1 - Math.abs(2 * lightnessDecimal - 1)) * saturationDecimal;
  const secondaryComponent = chroma * (1 - Math.abs(((normalizedHue / 60) % 2) - 1));
  const lightnessMatch = lightnessDecimal - chroma / 2;

  const rgbChannels = getRgbChannelsFromHue(normalizedHue, chroma, secondaryComponent);

  return `#${rgbChannels
    .map((channel) =>
      Math.round((channel + lightnessMatch) * 255)
        .toString(16)
        .padStart(2, '0')
    )
    .join('')
    .toUpperCase()}`;
};

export const getCssVariableHexColor = (cssVariable: string): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const value = getComputedStyle(document.documentElement).getPropertyValue(cssVariable).trim();

  return value ? hslTokenToHexColor(value) : null;
};
